module.exports = __webpack_public_path__ + "static/media/girl-691712_640.5535912e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/girl-691712_640.jpg
// module id = 42
// module chunks = 0